/**
 * Acciones sobre ordenes
 * @type {string[]}
 */
OrdenActionsService.$inject = ['$log', 'dialogService', '$http'];
export default function OrdenActionsService($log, dialogService, $http) {
    var TAG = 'OrdenActionsService: ';
    var DIALOG_ADD_ORDEN_TEMPLATE = require('./add/dialog-ordenes-add.html');
    var DIALOG_ADD_ORDEN_ID = 'dialog-ordenes-add';
    var DIALOG_ORDEN_ADD_ITEMS_TEMPLATE = require('./add-items/dialog-ordenes-add-items.html');
    var DIALOG_ORDEN_ADD_ITEMS_ID = 'dialog-ordenes-add-items';

    return {
        anyadirTareasAOrden: anyadirTareasAOrden,
        cambiarTareasDeOrden: cambiarTareasDeOrden,
        anyadirIncidenciasAOrden: anyadirIncidenciasAOrden,
        eliminarTareasDeOrden: eliminarTareasDeOrden,
        anyadirOrden: anyadirOrden,
        editarOrden: editarOrden
    };


    function anyadirItemsAOrden(codigos, titulo, tipoItem) {
        var options = {title: titulo};
        var datos = {
            codigos: codigos,
            tipoItem: tipoItem
        };
        var opcionesExtra = {deshabilitarBotones: true, devolverDatos: true};

        return dialogService.open(DIALOG_ORDEN_ADD_ITEMS_ID, DIALOG_ORDEN_ADD_ITEMS_TEMPLATE, datos, options, opcionesExtra);
    }

    function anyadirIncidenciasAOrden(codigosIncidencias) {
        var titulo = Lang.get('ordenes.title_add_incidencias_a_orden');
        return anyadirItemsAOrden(codigosIncidencias, titulo, 'incidencia');
    }

    function anyadirTareasAOrden(codigosTareas) {
        var titulo = Lang.get('ordenes.title_add_tareas_a_orden');
        return anyadirItemsAOrden(codigosTareas, titulo, 'tarea');
    }

    function anyadirOrden() {
        $log.debug(TAG + 'Añadiendo orden...');

        var titulo = Lang.get('ordenes.title_add_orden');
        var options = {title: titulo};
        var datos = {};
        var opcionesExtra = {deshabilitarBotones: true, devolverDatos: true};

        return dialogService.open(DIALOG_ADD_ORDEN_ID, DIALOG_ADD_ORDEN_TEMPLATE, datos, options, opcionesExtra);
    }

    function editarOrden(ordenId) {
        $log.debug(TAG + 'Editando orden ' + ordenId + '...');

        var titulo = Lang.get('ordenes.title_edit_orden');
        var options = {title: titulo};
        var datos = {ordenId: ordenId};
        var opcionesExtra = {deshabilitarBotones: true};

        return dialogService.open(DIALOG_ADD_ORDEN_ID, DIALOG_ADD_ORDEN_TEMPLATE, datos, options, opcionesExtra);
    }

    function eliminarTareasDeOrden(ordenId, codigosTareas) {
        return new Promise((resolve) => {
            const msg = Lang.get('ordenes.accion_delete_tareas_orden_title').toLowerCase() + ' '
                + Lang.choice('nombres.la_tarea', codigosTareas.length) + " " + codigosTareas.join(", ");

            const opciones = {
                title: Lang.get('ordenes.accion_delete_tareas_orden_title'),
                message: Lang.get('mensajes.confirma', {mensaje: msg}),
                onOk: function () {
                    $log.debug('Eliminando tareas de la orden ' + ordenId + '!');

                    const url = Sigo.var.path + '/ordenes/borrar-tareas';
                    const data = {
                        orden_id: ordenId,
                        codigos_tareas: codigosTareas
                    };

                    $http.post(url, data).then(
                        function (response) {
                            Sigo.UI.Messages.procesarRespuestaMultiplesAcciones(response.data);
                            resolve(response.data);
                        },
                        function () {
                            Sigo.UI.Messages.open(['Parece que ha ocurrido un error'], 0);
                        });
                }
            }
            Sigo.UI.Dialog.confirm(opciones);
        });
    }

    function cambiarTareasDeOrden(ordenId, codigosTareas) {
        $log.debug('Cambiando tareas de la orden ' + ordenId + '!');
        var titulo = Lang.get('ordenes.title_mover_tareas_orden');
        var options = {title: titulo};
        var datos = {
            ordenId: ordenId,
            codigos: codigosTareas
        };
        var opcionesExtra = {deshabilitarBotones: true, devolverDatos: true};

        return dialogService.open(DIALOG_ORDEN_ADD_ITEMS_ID, DIALOG_ORDEN_ADD_ITEMS_TEMPLATE, datos, options, opcionesExtra);
    }
}